import type { RichTableRowBlockModel } from '@blocksuite/affine-model';
import { BlockComponent } from '@blocksuite/std';
import { html } from 'lit';

import { richTableRowStyles } from './styles.js';

export class RichTableRowBlockComponent extends BlockComponent<RichTableRowBlockModel> {
  override connectedCallback() {
    super.connectedCallback();
    this.classList.add(richTableRowStyles);
  }

  override renderBlock() {
    // `display: contents` — the cells, not this element, are the grid items.
    return html`${this.renderChildren(this.model)}`;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'affine-rich-table-row': RichTableRowBlockComponent;
  }
}
